export default "__VITE_ASSET__Cci$vpL7__"